import { Handle, Position } from "reactflow";
const FinishNode = ({ id, totalDays, translate }) => {
  return (
    <div className="finish-node text-center d-flex align-items-center">
      <Handle type="target" position={Position.Top} id={`TargetTop${id}`} />
      <div>
        <p className="font-weight-bold mb-0 fs-5 ms-3">
          {translate("design_approval_process.nodes.ending")}
        </p>
      </div>
      <div className="ms-auto">
        <p className="font-weight-bold mb-0 fs-5 me-3">
          {totalDays > 1
            ? translate("design_approval_process.nodes.process-total-days", {
                dayCount: totalDays,
              })
            : translate("design_approval_process.nodes.process-total-day", {
                dayCount: totalDays,
              })}
        </p>
      </div>
    </div>
  );
};
export default FinishNode;
